export default "__VITE_ASSET__FkGktdoR__"